import { apolloClient } from "../../../apollo/graphql";
import { GET_BROKER_NAMES } from "../../../apollo/queries/processes";

export function distinctBrokerNames(names: string[]): string[] {
  const seen = new Set<string>();
  const distinct: string[] = [];
  for (const name of names) {
    const trimmed = name.trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    distinct.push(trimmed);
  }
  return distinct;
}

export async function fetchBrokerNameOptions(
  search: string,
  take = 25,
): Promise<string[]> {
  const term = search.trim();
  const { data } = await apolloClient.query<{ brokerNames: string[] }>({
    query: GET_BROKER_NAMES,
    variables: {
      search: term.length >= 1 ? term : undefined,
      take,
    },
    fetchPolicy: "network-only",
  });
  return distinctBrokerNames(data?.brokerNames ?? []);
}
